import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './sentry';
import { Sentry } from './sentry';
import { Analytics } from '@vercel/analytics/react';
import App from './App';

// Shown if the app ever crashes on render — a friendly, on-brand screen instead
// of a blank white page. Works with or without Sentry; when Sentry is enabled the
// crash is also reported automatically.
function ErrorFallback() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '24px',
      backgroundColor: '#faf6f0',
      color: '#1a1410',
      fontFamily: "'Cormorant Garamond', Georgia, serif",
    }}>
      <h1 style={{ fontSize: 'clamp(26px, 7vw, 36px)', fontWeight: 400, margin: '0 0 12px' }}>
        Something went wrong
      </h1>
      <p style={{ fontSize: '15px', fontWeight: 300, color: '#7a6b60', maxWidth: '420px', lineHeight: 1.7, margin: '0 0 28px' }}>
        Sorry — something broke on our end. Refreshing the page usually sorts it.
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{
          padding: '13px 32px',
          fontSize: '11px',
          fontFamily: 'inherit',
          fontWeight: 500,
          letterSpacing: '2px',
          textTransform: 'uppercase',
          color: '#faf6f0',
          backgroundColor: '#c9956e',
          border: 'none',
          cursor: 'pointer',
        }}
      >
        Reload
      </button>
    </div>
  );
}

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <App />
    </Sentry.ErrorBoundary>
    {/* Vercel Web Analytics — cookieless, aggregate; inert off Vercel/local. */}
    <Analytics />
  </React.StrictMode>
);
